import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserService } from '../../services/user.service';
import { RoleEnum } from 'server/shared/models/role.enum';

@Component({
  selector: 'jobs-index',
  templateUrl: 'jobs-index.html',
  styleUrls: ['jobs-index.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsIndexComponent {
  readonly RoleEnum = RoleEnum;

  constructor(private userService: UserService) {}

  role$ = this.userService.role$;
}
